// extracted by mini-css-extract-plugin
export default {"header":"JournalList_header__wPk-v","container":"JournalList_container__0ZyCy"};